import { render, staticRenderFns } from "./RecommenderUserManagement.vue?vue&type=template&id=09f8635b&scoped=true"
import script from "./RecommenderUserManagement.vue?vue&type=script&lang=ts"
export * from "./RecommenderUserManagement.vue?vue&type=script&lang=ts"
import style0 from "./RecommenderUserManagement.vue?vue&type=style&index=0&id=09f8635b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f8635b",
  null
  
)

export default component.exports